import Scama from "@/apis/Scama";

//State
const state = {
	scamas : []
};

//Getters
const getters = {
	allScamas: state => {
		return state.scamas
	}
};

//Actions
const actions = {
	async fetchScamas({commit}){
		const response = await Scama.getAll();
		commit('SET_SCAMAS', response.data)
	},

	reset({commit}){
		commit('SET_SCAMAS', []);
	}
};

//Mutations
const mutations = {
	SET_SCAMAS(state, scamas) {
		state.scamas = scamas;
	}
};

export default ({
	namespaced: true,
  state,
  mutations,
  actions,
  getters
})
